const BRAND = `${process.env.PUBLIC_URL}/brand`;

/* Official TNX coin render (brand deck) with halo, orbit ring + float */
export default function TvxCoin({ size = 300, className = "", testId }) {
    return (
        <div
            data-testid={testId}
            className={`relative shrink-0 ${className}`}
            style={{ width: `min(${size}px, calc(100vw - 40px))`, height: `min(${size}px, calc(100vw - 40px))` }}
        >
            <div className="absolute -inset-[34%] animate-halo rounded-full bg-[radial-gradient(circle,rgba(0,209,255,0.3)_0%,rgba(139,92,246,0.14)_50%,transparent_75%)]" />

            <div className="absolute -inset-[24%] rounded-full border border-white/[0.05]" />

            <div className="absolute -inset-[10%] animate-spin-slow rounded-full border border-cyan-400/20">
                <span className="absolute left-1/2 top-0 h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-cyber shadow-[0_0_14px_rgba(0,209,255,0.9)]" />
            </div>

            <img
                src={`${BRAND}/tvx-coin-hero.png`}
                alt="TNX — TAVONX Utility Token"
                loading="lazy"
                draggable={false}
                className="absolute inset-0 h-full w-full animate-float-y select-none object-contain drop-shadow-[0_0_60px_rgba(0,209,255,0.35)]"
            />
        </div>
    );
}
